import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useImagePreloader } from "../hooks/useImagePreLoader.jsx";
import { useAuth } from "../hooks/useAuth.jsx";
import { getImagesUrls } from "../utils/s3Utils.js";
import LoadingComponent from "../components/LoadingComponent";
import {
  AppBar,
  Box,
  Button,
  Collapse,
  Container,
  Drawer,
  Grid,
  IconButton,
  Link as MuiLink,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

//GET URL PRESIGNED OF IMAGES
const imageskeyRoutes = {
  s3logo: "assets/images/nh.png",
  s3delivery: "assets/icons/delivery.png",
  s3delivery2: "assets/icons/delivery2.png",
  s3uploadOrders: "assets/icons/upload.png",
  s3warehouse: "assets/icons/warehouse.png",
  s3home: "assets/icons/home.png",
  s3controlPanel: "assets/icons/control-panel.png",
  s3dashboard: "assets/icons/dashboard.png",
  s3deliveryNH: "assets/icons/delivery_nh.png",
  s3Dots: "assets/icons/dots.png",
};

const imageUrls = await getImagesUrls(imageskeyRoutes, "customLayout");

function CustomLayout(props) {
  const { children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [controlPanelOpen, setControlPanelOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { user, logout } = useAuth();
  const { allImagesLoaded, timeoutReached } = useImagePreloader(
    imageUrls,
    3000
  );
  let navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClickControlPanel = () => {
    setControlPanelOpen(!controlPanelOpen);
  };

  const handleListItemClick = (_event, index) => {
    setSelectedIndex(index);
  };

  const isOperator = user.user_type.includes("operator");
  const { is_staff: isStaff } = user;
  const isSeller = user.user_type.includes("seller");
  // next admin section steps:
  const isAdmin = user.user_type.includes("admin");

  const drawer = (
    <div className="container-drawer">
      <div className="drawer-s3logo">
        <img
          src="https://static.wixstatic.com/media/d57788_abb2a20628fb49f892f533e29e46b5cd~mv2.png"
          alt="Logo NH"
          style={{ width: "175px", marginTop: "10px" }}
        />
      </div>
      <div className="container-user-info">
        <p className="flex-left fw-medium">
          Hola, {user ? user.full_name : ""}
        </p>
        <p className="flex-left fw-light">
          {user ? user.user_type.join(" | ") : ""}
        </p>
        {user?.admin_plan?.plan_name && (
          <p className="flex-left fw-light">
            Plan: {user.admin_plan.plan_name}
          </p>
        )}
      </div>

      <div
        className="drawer-body-container"
        style={{ height: "100px", marginBottom: "1rem" }}
      >
        <List
          sx={{ width: "100%", maxWidth: 360 }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          className="custom-list"
        >
          <Link to={"my-account"} id={"link-to-account"}>
            <ListItem
              button
              selected={selectedIndex === 1}
              onClick={(event) => handleListItemClick(event, 1)}
            >
              <ListItemText primary={"Mi Cuenta"} />
            </ListItem>
          </Link>
        </List>
      </div>

      <div className="drawer-buttons-container">
        <Link
          to={"upload-requests"}
          className="upload-requests"
          id={"link-to-new-request"}
        >
          <Button variant="contained">
            <img
              src={imageUrls.s3uploadOrders}
              alt="upload"
              className="drawer-icon"
              style={{ width: "40px" }}
            />

            <p>Carga tus órdenes</p>
          </Button>
        </Link>
      </div>

      <div className="drawer-body-container">
        <List
          sx={{ width: "100%", maxWidth: 360 }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          className="custom-list"
        >
          <Link to={"/home"} id={"link-to-home"}>
            <ListItem
              button
              selected={selectedIndex === 0}
              onClick={(event) => handleListItemClick(event, 0)}
            >
              <ListItemIcon>
                <img
                  src={imageUrls.s3home}
                  alt="home"
                  className="drawer-icon"
                />
              </ListItemIcon>
              <ListItemText primary={"Inicio"} />
            </ListItem>
          </Link>
          {(isSeller || isAdmin) && (
            <Link>
              <ListItem
                button
                selected={selectedIndex === 2}
                onClick={(event) => {
                  event.preventDefault();
                  handleListItemClick(event, 2);
                  navigate("dashboard");
                }}
              >
                <ListItemIcon>
                  <img
                    src={imageUrls.s3dashboard}
                    alt="DeliveryResume"
                    className="drawer-icon"
                  />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItem>
            </Link>
          )}

          {(isOperator || isSeller || isAdmin) && (
            <Link>
              <ListItem
                button
                selected={selectedIndex === (isAdmin || isSeller ? 3 : 2)} // Dynamically set selected index
                onClick={(event) => {
                  event.preventDefault();
                  const index = isAdmin || isSeller ? 3 : 2;
                  handleListItemClick(event, index);
                  navigate("deliveries-resume");
                }}
              >
                <ListItemIcon>
                  <img
                    src={imageUrls.s3deliveryNH}
                    alt="DeliveryResume"
                    className="drawer-icon"
                  />
                </ListItemIcon>
                <ListItemText primary="Deliveries" />
              </ListItem>
            </Link>
          )}

          {(isAdmin || isStaff) && (
            <Link>
              <ListItem
                button
                selected={selectedIndex === (isAdmin || isSeller ? 4 : 3)} // Dynamically set selected index
                onClick={(event) => {
                  event.preventDefault();
                  const index = isAdmin || isSeller ? 4 : 3;
                  handleListItemClick(event, index);
                  navigate("pickings");
                }}
              >
                <ListItemIcon>
                  <img
                    src={imageUrls.s3deliveryNH}
                    alt="Picking"
                    className="drawer-icon"
                  />
                </ListItemIcon>
                <ListItemText primary="My Pickups" />
              </ListItem>
            </Link>
          )}
          {true && (
            <>
              <ListItem
                button
                onClick={(event) => {
                  const index = isAdmin || isSeller ? 5 : 4;
                  handleListItemClick(event, index);
                  handleClickControlPanel();
                }}
                id="requests-collapse-button"
                selected={selectedIndex === (isAdmin || isSeller ? 5 : 4)} // Dynamically set selected index
              >
                <ListItemIcon>
                  <img
                    src={imageUrls.s3controlPanel}
                    alt="panel de control"
                    className="drawer-icon"
                    style={{ width: "36px" }}
                  />
                </ListItemIcon>
                <ListItemText primary="Panel de Control" />
                {controlPanelOpen ? (
                  <i
                    className="material-icons-outlined"
                    style={{ width: "36px" }}
                  >
                    expand_less
                  </i>
                ) : (
                  <i
                    className="material-icons-outlined"
                    style={{ width: "36px" }}
                  >
                    expand_more
                  </i>
                )}
              </ListItem>
              <Collapse in={controlPanelOpen} timeout="auto" unmountOnExit>
                <List component="div">
                  {isSeller ? (
                    <>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 15}
                          onClick={(event) => {
                            event.preventDefault();
                            handleListItemClick(event, 15);
                            navigate("configuration/ecommerce");
                          }}
                        >
                          <ListItemIcon>
                            <img
                              src={imageUrls.s3Dots}
                              alt="Integración E-commerce"
                              className="drawer-icon"
                            />
                          </ListItemIcon>
                          <ListItemText primary="Integración E-commerce" />
                        </ListItem>
                      </Link>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 16}
                          onClick={(event) => {
                            event.preventDefault();
                            handleListItemClick(event, 16);
                            navigate("configuration/webhooks");
                          }}
                        >
                          <ListItemIcon>
                            <img
                              src={imageUrls.s3Dots}
                              alt="Webhooks"
                              className="drawer-icon"
                            />
                          </ListItemIcon>
                          <ListItemText primary="Webhooks" />
                        </ListItem>
                      </Link>
                    </>
                  ) : null}

                  {isAdmin && (
                    <>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 6}
                          onClick={(event) => {
                            event.preventDefault();

                            handleListItemClick(event, 6);
                            navigate("my-sellers");
                          }}
                        >
                          <ListItemText primary="Mis sellers" />
                        </ListItem>
                      </Link>
                      {isStaff && (
                        <Link>
                          <ListItem
                            button
                            selected={selectedIndex === 20}
                            onClick={(event) => {
                              event.preventDefault();
                              handleListItemClick(event, 20);
                              navigate("my-admins");
                            }}
                          >
                            <ListItemText primary="Mis admins" />
                          </ListItem>
                        </Link>
                      )}
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 8}
                          onClick={(event) => {
                            event.preventDefault();

                            handleListItemClick(event, 6);
                            navigate("my-partnerships");
                          }}
                        >
                          <ListItemText primary="Mis Alianzas" />
                        </ListItem>
                      </Link>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 18}
                          onClick={(event) => {
                            event.preventDefault();

                            handleListItemClick(event, 18);
                            navigate("my-providers-credentials");
                          }}
                        >
                          <ListItemText primary="Mis proveedores" />
                        </ListItem>
                      </Link>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 19}
                          onClick={(event) => {
                            event.preventDefault();

                            handleListItemClick(event, 18);
                            navigate("external-integrations");
                          }}
                        >
                          <ListItemText primary="Mis servicios externos" />
                        </ListItem>
                      </Link>
                    </>
                  )}

                  {isStaff && (
                    <>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 7}
                          onClick={(event) => {
                            event.preventDefault();

                            handleListItemClick(event, 7);
                            navigate("my-shipping-zones");
                          }}
                        >
                          <ListItemText primary="Mis Zonas" />
                        </ListItem>
                      </Link>
                    </>
                  )}

                  {(isAdmin || isSeller) && (
                    <>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 21}
                          onClick={(event) => {
                            event.preventDefault();
                            handleListItemClick(event, 21);
                            navigate("pickup-requests/create");
                          }}
                        >
                          {/* <ListItemIcon>
                            <img
                              src={imageUrls.s3Dots}
                              alt="Solicitudes de retiro"
                              className="drawer-icon"
                            /> 
                          </ListItemIcon>*/}
                          <ListItemText primary="Solicitudes de retiro" />
                        </ListItem>
                      </Link>
                      <Link>
                        <ListItem
                          button
                          selected={selectedIndex === 22}
                          onClick={(event) => {
                            event.preventDefault();
                            handleListItemClick(event, 22);
                            navigate("pickup-requests/assign");
                          }}
                        >
                         {/*  <ListItemIcon>
                            <img
                              src={imageUrls.s3Dots}
                              alt="Asignar a manifiesto"
                              className="drawer-icon"
                            /> 
                          </ListItemIcon>*/}
                          <ListItemText primary="Manifiestos" />
                        </ListItem>
                      </Link>
                    </>
                  )}
                </List>
              </Collapse>
            </>
          )}

          {isStaff && (
            <Link>
              <ListItem
                button
                selected={selectedIndex === 14}
                onClick={(event) => {
                  event.preventDefault();
                  handleListItemClick(event, 14);
                  navigate("mailing");
                }}
              >
                <ListItemText primary="Mailing" />
              </ListItem>
            </Link>
          )}
        </List>
        <MuiLink
          onClick={logout}
          className="exit-container"
          id={"button-close-session"}
        >
          <i className="material-icons-outlined">exit_to_app</i>{" "}
          <p className="exit-btn">Cerrar sesión</p>
        </MuiLink>
      </div>
    </div>
  );

  const drawerWidth = 235;

  return (
    <>
      {!allImagesLoaded && !timeoutReached ? (
        <LoadingComponent />
      ) : (
        <>
          <Box sx={{ display: "flex" }}>
            <Box
              component="nav"
              sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
              aria-label="mailbox folders"
            >
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                className="mobile-drawer"
                sx={{
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
              >
                {drawer}
              </Drawer>
              <Drawer
                variant="permanent"
                className="desktop-drawer"
                sx={{
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
              >
                {drawer}
              </Drawer>
            </Box>
            <AppBar position="fixed" className="custom-appbar">
              <Grid container>
                <Grid item xs={3} className="flex-center">
                  <IconButton
                    aria-label="open drawer"
                    onClick={handleDrawerToggle}
                    id={"button-open-menu"}
                  >
                    <i className="material-icons-outlined">menu</i>
                  </IconButton>
                </Grid>
                <Grid item xs={6} className="flex-center">
                  <div className="appbar-logo"></div>
                </Grid>
                <Grid item xs={3} className="flex-center"></Grid>
              </Grid>
            </AppBar>
            <Container className="app-container" maxWidth={false}>
              <main className="app-main">{children}</main>
            </Container>
          </Box>
        </>
      )}
    </>
  );
}

export default CustomLayout;
